import { render, staticRenderFns } from "./scenes-view.vue?vue&type=template&id=23a222d2&scoped=true"
import script from "./scenes-view.vue?vue&type=script&lang=js"
export * from "./scenes-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a222d2",
  null
  
)

export default component.exports